import { Editor, Element, Range, Transforms } from "slate";

import ElementType from "../../../type/slate/ElementType";

const withLinks = (editor: Editor): Editor => {
  const { insertText, isInline } = editor;

  // Treat `Link` elements as inline elements, allowing them to flow within text blocks.
  editor.isInline = (element: Element) => {
    return Element.isElementType(element, ElementType.LINK) || isInline(element);
  };

  // Address an UX issue where typing at the very end of a link would add the new text
  // inside the link element itself, rather than after it.
  // For example editing links in JIRA is working in similar way.
  editor.insertText = (text) => {
    if (editor.selection && Range.isCollapsed(editor.selection)) {
      const [link] = Editor.nodes(editor, {
        match: (node) =>
          !Editor.isEditor(node) &&
          Element.isElement(node) &&
          Element.isElementType(node, ElementType.LINK),
      });

      if (link) {
        const [, linkPath] = link;
        const end = Editor.end(editor, linkPath);

        if (editor.selection.anchor.offset === end.offset) {
          Transforms.move(editor, { unit: "offset" });
        }
      }
    }

    insertText(text);
  };

  return editor;
};

export default withLinks;
